import useForceRerender from './useForceRerender';

export default useForceRerender;
